var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.05409 0.504471C4.97455 0.421749 4.86475 0.375 4.75 0.375C4.63525 0.375 4.52545 0.421749 4.44591 0.504471L0.930276 4.16072C0.768783 4.32867 0.774019 4.59574 0.941971 4.75722C1.10992 4.91871 1.37699 4.91348 1.53848 4.74553L4.75 1.40554L7.96154 4.74553C8.12303 4.91348 8.39011 4.91871 8.55801 4.75722C8.72598 4.59574 8.73121 4.32867 8.56971 4.16072L5.05409 0.504471ZM5.05409 11.4955C4.97455 11.5783 4.86475 11.625 4.75 11.625C4.63525 11.625 4.52545 11.5783 4.44591 11.4955L0.930276 7.83926C0.768783 7.67136 0.774019 7.40428 0.941971 7.24279C1.10992 7.08129 1.37699 7.08652 1.53848 7.25449L4.75 10.5944L7.96154 7.25449C8.12303 7.08652 8.39011 7.08129 8.55801 7.24279C8.72598 7.40428 8.73121 7.67136 8.56971 7.83926L5.05409 11.4955Z",
    fill: "white",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sort_icon.2ce1929dce740d09bc14c019ea9feb6a.svg";
export { ForwardRef as ReactComponent };